import * as React from "react";
import classnames from "classnames";
import { useApiClient, Stores } from "@grandvisionhq/api-client";
import { Button } from "@grandvisionhq/common";
import { Util, Form, Input, Select } from "@grandvisionhq/forms";
import { Skeleton, Alert } from "@grandvisionhq/iris-ui";
import { withGetCoordinates } from "@grandvisionhq/locations";
import { withApiConfig, withIntl, useIntl } from "@grandvisionhq/state";
import { getDistance, formatDistance, findNearestCoordinates } from "@grandvisionhq/utils";
/* empty css                          */
const cityRegex = /^([a-zA-Z_\s\-]*)$/;
class PreferredStoreFinder extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      search: "",
      isNoResults: false,
      stores: {
        list: []
      }
    };
    this.countries = [];
    this.getDropdownOptions = (distanceUnit) => {
      const { location, stores } = this.state;
      let options = {};
      stores.list.map((item) => {
        const { town, streetName, streetNumber, globalStoreId: value } = item;
        const distance = getDistance(location || {}, item);
        let label = `${town} - ${streetName}`;
        if (streetNumber) {
          label += ` ${streetNumber}`;
        }
        if (distance !== Infinity) {
          label += ` (± ${formatDistance(distance, distanceUnit, {
            precision: 0
          })})`;
        }
        options = { ...options, [label]: value };
      });
      return options;
    };
    this.handleBlur = () => {
      if (!this.state.isTouched) {
        this.setState({ isTouched: true });
      }
    };
    this.handleSearchChange = ({ value: search }) => this.setState({ search, isNoResults: false });
    this.handleStoreSelect = (value) => {
      const { onStoreSelect } = this.props;
      const { list } = this.state.stores;
      const store = list.find((item) => item.globalStoreId === value);
      if (!store) {
        return;
      }
      onStoreSelect(store);
    };
    this.handleClickCTA = async () => {
      const { search } = this.state;
      if (!search || !this.isPostalCodeOrCity(search)) {
        return;
      }
      const result = await this.getCoordinatesResult(
        this.checkForPostalCode(search)
      );
      if (!result) {
        return this.setState({ isNoResults: true });
      }
      const l = result.coordinates;
      const location = { lat: l.lat, lon: l.lng };
      const list = findNearestCoordinates(location, this.props.stores, {
        limit: 10
      });
      const selected = list[0];
      this.setState(
        {
          isNoResults: false,
          location,
          stores: { selected, list }
        },
        () => selected?.globalStoreId && this.handleStoreSelect(selected?.globalStoreId)
      );
    };
    this.getDistinctCountries = () => {
      const { stores } = this.props;
      const result = [];
      stores.forEach(({ country }) => !result.includes(country) && result.push(country));
      return result;
    };
    this.getCoordinatesResult = async (input) => {
      const { apiConfig, getCoordinates } = this.props;
      try {
        return await getCoordinates(apiConfig.locationsUrl, {
          query: input
        });
      } catch (e) {
        console.error(e);
      }
    };
    this.validateCity = (v) => v.trim() ? cityRegex.test(v) : false;
    this.isPostalCodeOrCity = (v) => [Util.validations.getPostalCodeRegex(this.props.intl.country), this.validateCity].some(
      (validator) => {
        return validator instanceof Function ? validator(v) : validator?.test(v);
      }
    );
  }
  componentDidMount() {
    this.countries = this.getDistinctCountries();
  }
  static getDerivedStateFromProps({ selected, stores }, prevState) {
    if (!prevState.search && selected && selected?.globalStoreId !== prevState.stores.selected?.globalStoreId) {
      return {
        ...prevState,
        isNoResults: false,
        location: selected,
        stores: {
          selected,
          list: findNearestCoordinates(selected, stores, { limit: 10 })
        }
      };
    }
    return null;
  }
  render() {
    const { intl } = this.props;
    const { search, stores, isNoResults, isTouched } = this.state;
    const { list } = stores;
    if (!this.props.stores.length) {
      return /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, intl.getLabel("stores.preferredStore.errorMessage"));
    }
    const isValid = this.isPostalCodeOrCity(search) && isTouched;
    const isInvalid = !this.isPostalCodeOrCity(search) && isTouched;
    const inputClasses = classnames("form-control__input", "preferred-store-finder__input", {
      _is_valid: isValid,
      _is_invalid: isInvalid
    });
    return /* @__PURE__ */ React.createElement("article", { className: "preferred-store-finder" }, /* @__PURE__ */ React.createElement("div", { className: "preferred-store-finder__main" }, isNoResults && /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, intl.getLabel("stores.preferredStore.noResults")), /* @__PURE__ */ React.createElement("div", { className: "preferred-store-finder__search" }, /* @__PURE__ */ React.createElement("label", { className: "form-control__label" }, intl.getLabel("stores.preferredStore.search.label"), /* @__PURE__ */ React.createElement("span", { className: "form-control__asterisk" }, "*")), /* @__PURE__ */ React.createElement(
      Form,
      {
        name: "preferred-store-finder",
        onSubmit: this.handleClickCTA,
        className: "preferred-store-finder__search-form"
      },
      /* @__PURE__ */ React.createElement("div", { className: "preferred-store-finder__search-form-content" }, /* @__PURE__ */ React.createElement("div", { className: "preferred-store-finder__input-wrapper" }, /* @__PURE__ */ React.createElement(
        Input,
        {
          id: "search",
          "data-t": "search",
          className: inputClasses,
          placeholder: intl.getLabel("stores.form.findStore.fields.location.placeholder"),
          onChange: this.handleSearchChange,
          onBlur: this.handleBlur
        }
      ), !this.isPostalCodeOrCity(search) && isTouched && /* @__PURE__ */ React.createElement("span", { className: "form-control__error" }, intl.getLabel("checkout.address.city.errorMessage"))), /* @__PURE__ */ React.createElement(
        Button,
        {
          className: "preferred-store-finder__button",
          color: "secondary",
          type: "submit",
          variant: !search || !this.isPostalCodeOrCity(search) ? "outline" : "solid",
          caption: intl.getLabel("stores.preferredStore.cta"),
          onClick: this.handleClickCTA
        }
      ))
    )), list.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "preferred-store-finder__result" }, /* @__PURE__ */ React.createElement("label", { className: "form-control" }, /* @__PURE__ */ React.createElement("span", { className: "form-control__label" }, intl.getLabel("stores.preferredStore.result.label")), /* @__PURE__ */ React.createElement(
      Select,
      {
        required: true,
        id: "result",
        name: "result",
        onChange: this.handleStoreSelect,
        options: this.getDropdownOptions(intl.distanceUnit)
      }
    )))));
  }
  checkForPostalCode(search) {
    const postCodeRegex = Util.validations.getPostalCodeRegex(this.props.intl.country);
    return postCodeRegex?.test(search) ? `postcode ${search}` : search;
  }
}
const PreferredStoreFinderLoader = () => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    Skeleton,
    {
      height: 80,
      width: "100%",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": getLabel("common.loadingText")
    },
    /* @__PURE__ */ React.createElement("rect", { width: "80%", height: "32px", rx: "4", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("rect", { width: "50%", height: "32px", rx: "4", fill: "currentColor", y: "48" })
  );
};
const WithStores = ({ apiConfig, ...rest }) => {
  const [isLoading, stores, error] = useApiClient(Stores.list, null, apiConfig.storesUrl);
  if (error) {
    throw error;
  }
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(PreferredStoreFinderLoader, null);
  }
  return /* @__PURE__ */ React.createElement(PreferredStoreFinder, { stores: stores || [], apiConfig, ...rest });
};
WithStores.displayName = "WithStores(PreferredStoreFinder)";
const PreferredStoreFinder$1 = withGetCoordinates(withApiConfig(withIntl(WithStores)));
export {
  PreferredStoreFinder,
  PreferredStoreFinderLoader,
  PreferredStoreFinder$1 as default
};
//# sourceMappingURL=PreferredStoreFinder.js.map
